"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.olapicResponseCategorySchema = void 0;
var _zod = require("zod");
var _OlapicResponseCategoryItem = require("./OlapicResponseCategoryItem");
const olapicResponseCategorySchema = exports.olapicResponseCategorySchema = _zod.z.object({
  data: _OlapicResponseCategoryItem.olapicCategoryItem
});
